import { render } from "./updateoptions.vue?vue&type=template&id=67167af0"
import script from "./updateoptions.vue?vue&type=script&lang=js"
export * from "./updateoptions.vue?vue&type=script&lang=js"

import "./updateoptions.vue?vue&type=style&index=0&id=67167af0&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__